/*
 * @Author: your name
 * @Date: 2021-02-27 16:09:58
 * @LastEditTime: 2023-03-31 17:51:14
 * @LastEditors: heming 984507092@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /mall-admin-web-master/src/store/modules/user.js
 */
import { login, logout, getInfo, getMenus, getSmsCodeLogin } from "@/api/login";
import { getToken, setToken, removeToken } from "@/utils/auth";

const user = {
  state: {
    token: getToken(),
    name: "",
    avatar: "",
    roles: [],
    userId: "",
    account: ""
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
    SET_USERID: (state, userId) => {
      console.log(userId);
      state.userId = userId;
    },
    SET_ACCOUNT: (state, account) => {
      state.account = account;
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim();
      return new Promise((resolve, reject) => {
        login(username, userInfo.password)
          .then(response => {
            const data = response.data;
            const copyData = JSON.stringify(data);
            const tokenStr = data.tokenHead + data.token;
            setToken(tokenStr);
            commit("SET_TOKEN", tokenStr);
            commit("SET_NAME", data.username);
            commit("SET_AVATAR", data.icon);
            commit("SET_USERID", data.id);
            commit("SET_ACCOUNT", data.name);
            window.localStorage.setItem("userId", data.id);
            window.localStorage.setItem("userInfo", copyData);
            resolve();
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    SmsLogin({ commit }, { mobile, smsCode }) {
      return new Promise((resolve, reject) => {
        getSmsCodeLogin({ mobile, smsCode })
          .then(response => {
            const data = response.data;
            const copyData = JSON.stringify(data);
            const tokenStr = data.tokenHead + data.token;
            setToken(tokenStr);
            commit("SET_TOKEN", tokenStr);
            commit("SET_NAME", data.username);
            commit("SET_AVATAR", data.icon);
            commit("SET_USERID", data.id);
            commit("SET_ACCOUNT", data.name);
            window.localStorage.setItem("userId", data.id);
            window.localStorage.setItem("userInfo", copyData);
            resolve();
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getMenus()
          .then(response => {
            const data = response.data;
            // console.log(data, 'GETINFO')
            if (data.length > 0) {
              commit("SET_ROLES", data.roles);
              resolve(response);
            } else {
              commit("SET_ROLES", data.roles);
              resolve(response);
            }
            // if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            //   commit('SET_ROLES', data.roles)
            // } else {
            //   reject('getInfo: roles must be a non-null array !')
            // }

            // commit('SET_NAME', data.username)
            // commit('SET_AVATAR', data.icon)
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token)
          .then(() => {
            commit("SET_TOKEN", "");
            commit("SET_ROLES", []);
            removeToken();
            resolve();
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit("SET_TOKEN", "");
        removeToken();
        resolve();
      });
    }
  }
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js